import React, {useEffect, useState} from 'react'
import {Container} from 'react-bootstrap';
import {useDispatch, useSelector} from 'react-redux';
import { resetConfirmationDialog, toggleConfirmationDialog, toggleLoader } from '../../shared/actions/setting';
import { deleteCorporate, getCorporates } from '../../utils/mainServices';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import FeatherIcon from 'feather-icons-react';
import FormCorporate from './formCorporate';
import SearchInput from '../../shared/components/SearchInput';
import useColumnSelector from '../../shared/components/useColumnSelector';

const CorporatePageTable = () => {
  const dispatch = useDispatch();
  const [allCorporateList, setAllCorporateList] = useState([]);
  const {t} = useTranslation();
  const [ deleteCorporateId, setDeleteCorporateId] = useState(null);
  const [shouldFetchData, setShouldFetchData] = useState(false);
  const [isFormCorporateVisible, setIsFormCorporateVisible] = useState(false);
  const [selectedCorporate, setSelectedCorporate] = useState(null)
  const confirmationDialog = useSelector(state => {
      return state.setting.confirmationDialog
    });
  
  const [searchText, setSearchText] = useState('');
  const { ColumnSelector, columnFilter, columnFilterReadOnly } = useColumnSelector('corporate-table');


  //Fetch the all corporates
  useEffect(() => {
    const fetchCorporates = async () => {
      dispatch(toggleLoader(true))
      try {
        const data = await getCorporates(); 
        setAllCorporateList(data.content);
      } catch (error) {
        console.error('Error fetching corporates:', error); 
        toast.error("Corporate can't be fetched");
      } finally {
        dispatch(toggleLoader(false))
      }
    };

    fetchCorporates();
  }, [shouldFetchData]); 

  //Add corporate
  function handleAddCorporate() {
    setIsFormCorporateVisible (true)
  }

  //Edit corporate
  function gotoCorporateEdit(corporate) {
    setSelectedCorporate(corporate)
    setIsFormCorporateVisible (true)
  }

  const hideFormCorporate = (state) => {
    setIsFormCorporateVisible (false)
    setSelectedCorporate(null)
    if (state) {
      setShouldFetchData(prev => !prev);
    }
  }

  //delete corporate
  useEffect(() => {
      if (!confirmationDialog || !confirmationDialog.onSuccess || !deleteCorporateId) {
        return;
      }
    
      const handleDelete = async () => {
        try {
          dispatch(toggleLoader(true));
          await deleteCorporate(deleteCorporateId);
          toast.success("Corporate deleted succesfully");
          setShouldFetchData(prev => !prev);
        } catch (error) {
          if (error.response && error.response.status === 422) {
            toast.warn(error.response.data.message);
          } else {
            toast.error("Something went wrong");
          }
        } finally {
          setDeleteCorporateId(null);
          dispatch(toggleLoader(false));
          dispatch(resetConfirmationDialog());
        }
      };
    
      handleDelete();
    }, [confirmationDialog, deleteCorporateId]);

  function handleDeleteCorporate(corporate) {
    setDeleteCorporateId(corporate.id);
      dispatch(toggleConfirmationDialog({
        isVisible: true,
        confirmationHeading: t("confirmation_msg.ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_CORPORATE_WITH_NAME", { name: corporate.name }),
        confirmationDescription: t("confirmation_msg.THE_DELETE_ACTION_WILL_REMOVE_THE_CORPORATE_WITH_NAME", { name: corporate.name })
      }));
    }
  
  const filteredCorporateList = allCorporateList.filter(corporate => {
    const searchLower = searchText.toLowerCase();
    return (
      (corporate.name && corporate.name.toLowerCase().includes(searchLower)) ||
      (corporate.contactName && corporate.contactName.toLowerCase().includes(searchLower)) ||
      (corporate.contactPhoneNumber && corporate.contactPhoneNumber.toLowerCase().includes(searchLower))
    );
  });

  return (
    <div className={"half-list-container"}>
      <Container>
        <div className={"single-card m-rl-m-8 p-a-16"}>
          <div className={"sa-table-flex sa-table-top"}>
            <span className="sa-table-top-left-items">
              <ColumnSelector/>
              <SearchInput
                value={searchText}
                onValueChange={setSearchText}
                placeholder="Search Corporate"
              />
            </span>
            <div className="sa-table-top-right-items">
              <span>
                <div className="xin-pull-right">
                  <span className="sa-table-icon-flex sa-table-filter-position">
                    <button
                      onClick={handleAddCorporate}
                      className={`sa-table-btn-secondary sa-table-btn-secondary-wide sa-table-float-right`}>
                      <FeatherIcon
                        icon={`plus`}
                        className={"sa-table-icon-size"}/> Create Corporate
                    </button>
                  </span>
                </div>
              </span>
            </div>
          </div>
          <div id="main3" className="sa-table-container xindicate-calc-height">
            <table className="table table-borderless sa-table-width">
              <thead>
              <tr>
                <th hidden={columnFilterReadOnly("No.")} className={"sa-table-head-sticky"}>No.</th>
                <th hidden={columnFilter("Name")} className={"sa-table-head-sticky"}>Name</th>
                <th hidden={columnFilter("Contact Name")} className={"sa-table-head-sticky"}>Contact Name</th>
                <th hidden={columnFilter("Contact Number")} className={"sa-table-head-sticky"}>Contact Number</th>
                <th hidden={columnFilter("Contact Email")} className={"sa-table-head-sticky"}>Contact Email</th>
                <th hidden={columnFilter("Action")} className={"sa-table-head-sticky"}>Action</th>
              </tr>
              </thead>
              <tbody>
              {filteredCorporateList.map((corporate, index) => (
                  <tr key={index}>
                    <td hidden={columnFilterReadOnly("No.")} className={'sa-table-data'}>{index + 1}</td>
                    <td hidden={columnFilter("Name")} className={'sa-table-data'}>{corporate.name}</td>
                    <td hidden={columnFilter("Contact Name")} className={'sa-table-data'}>{corporate.contactName}</td>
                    <td hidden={columnFilter("Contact Number")} className={'sa-table-data'}>{corporate.contactPhoneNumber}</td>
                    <td hidden={columnFilter("Contact Email")} className={'sa-table-data'}>{corporate.contactEmail}</td>
                    <td hidden={columnFilter("Action")} className={'sa-table-item-align'}>
                      <div className='sa-table-item-flex'>
                        <div className="sa-table-actions sa-action-m" data-toggle="tooltip" title={t("button.EDIT")}>
                          <FeatherIcon
                            onClick={() => gotoCorporateEdit(corporate)}
                            className={`table-action ` }
                            icon={"edit"}
                          />
                        </div>
                        <div className="sa-table-actions sa-action-m" data-toggle="tooltip" title={t("button.DELETE")}>
                          <FeatherIcon
                            className={ 'text-red feather-trash'}
                            icon={`trash-2`}
                            onClick={() => {
                              handleDeleteCorporate(corporate);
                            }}
                          />
                        </div>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      {isFormCorporateVisible && (<FormCorporate 
                                  selectedCorporate={selectedCorporate} 
                                  onClose={hideFormCorporate} 
                                  formType={selectedCorporate ? "edit" : "add"} 
                                />
      )}
    </Container>
  </div>
  )
}

export default CorporatePageTable;
